import { render, staticRenderFns } from "./ModuleRow.vue?vue&type=template&id=c651f378&scoped=true"
import script from "./ModuleRow.vue?vue&type=script&lang=js"
export * from "./ModuleRow.vue?vue&type=script&lang=js"
import style0 from "./ModuleRow.vue?vue&type=style&index=0&id=c651f378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c651f378",
  null
  
)

export default component.exports